const COURSE_OUTCOMES = {
  fundamental_digital_literacy: [
    'Navigate computers, files, and the internet with confidence',
    'Create and format professional documents with word processing tools',
    'Communicate effectively using email and online platforms',
    'Use social media and search tools to find reliable information',
    'Apply basic digital safety practices to protect your data',
    'Complete a real-world internship applying everyday digital skills',
  ],
  fullstack_web_development: [
    'Build responsive frontends with HTML, CSS, JavaScript, and React',
    'Design and consume REST APIs using Python, PHP, and Node concepts',
    'Model and query data with SQL and MongoDB',
    'Manage code with Git/GitHub and collaborate on team projects',
    'Deploy fullstack applications with modern tooling and best practices',
    'Deliver a capstone project from UI to database and presentation',
  ],
  advanced_graphic_design: [
    'Create professional visuals in Adobe Photoshop and Illustrator',
    'Apply color theory, typography, and layout to brand-ready designs',
    'Develop logos, social assets, and marketing collateral',
    'Build a cohesive brand identity across print and digital media',
    'Follow modern design trends while maintaining visual consistency',
    'Present a portfolio-ready design project for client scenarios',
  ],
  UI_UX_design: [
    'Conduct user research and translate insights into design decisions',
    'Structure information architecture and intuitive user flows',
    'Prototype interactive interfaces with industry-standard tools',
    'Apply visual design principles for accessible, polished UI',
    'Validate designs through usability thinking and iteration',
    'Build a capstone UX case study for your professional portfolio',
  ],
  data_analysis_and_visualization: [
    'Clean, transform, and analyze datasets using Excel and SQL',
    'Build interactive dashboards and reports with Power BI',
    'Apply statistics to interpret trends and support decisions',
    'Automate analysis workflows with Python for data analytics',
    'Visualize insights clearly for business and technical audiences',
    'Complete a capstone analytics project with real-world datasets',
  ],
  digital_marketing: [
    'Optimize websites and content for search engines (SEO)',
    'Plan and run Google Ads search and display campaigns',
    'Grow brands through content and social media marketing',
    'Set up and manage Google Business Profile for local visibility',
    'Track campaign performance with Google Analytics',
    'Execute a practical internship applying multi-channel marketing',
  ],
  diploma_in_information_technology: [
    'Master Microsoft Office for documents, spreadsheets, and presentations',
    'Produce desktop publishing and basic graphics with Corel Draw & Photoshop',
    'Automate office tasks and manage files efficiently',
    'Use email, internet tools, and blogging for communication',
    'Apply IT fundamentals across workplace scenarios',
    'Gain hands-on experience through a guided internship',
  ],
  software_engineering: [
    'Apply SDLC models and software engineering best practices',
    'Design systems using analysis and architecture tools',
    'Implement, test, and maintain production-quality software',
    'Manage software projects with agile and traditional methodologies',
    'Integrate CI/CD and DevOps principles into delivery workflows',
    'Ship software solutions through internship-backed experience',
  ],
  mobile_app_development: [
    'Design mobile-first interfaces and smooth user interactions',
    'Build cross-platform apps with Flutter and React Native',
    'Write Dart code and structure scalable mobile architectures',
    'Connect apps to APIs and handle real-world mobile data flows',
    'Test, debug, and prepare apps for deployment',
    'Publish a functional mobile app project by course completion',
  ],
  computer_programming: [
    'Think algorithmically and solve problems with structured logic',
    'Write clean code using data structures and control flow',
    'Apply design patterns to build maintainable programs',
    'Choose the right language and approach for different tasks',
    'Debug, refactor, and document code professionally',
    'Demonstrate programming skills through internship projects',
  ],
  database_management: [
    'Design relational schemas and write efficient SQL queries',
    'Administer Oracle and MongoDB databases for real applications',
    'Model data for performance, integrity, and scalability',
    'Implement backup, recovery, and security fundamentals',
    'Integrate databases into application workflows',
    'Apply database skills in a practical internship setting',
  ],
  cyber_security: [
    'Identify threats, vulnerabilities, and attack surfaces',
    'Secure networks, systems, and web applications',
    'Implement access control, encryption, and monitoring',
    'Perform ethical hacking and penetration testing basics',
    'Respond to incidents using industry frameworks and tools',
    'Complete a hands-on cybersecurity capstone and internship',
  ],
  artificial_intelligence_and_machine_learning: [
    'Understand AI foundations, search, and reasoning concepts',
    'Build and evaluate machine learning models on real data',
    'Apply NLP techniques to text-based problems',
    'Connect AI theory to practical business use cases',
    'Experiment with model training, testing, and iteration',
    'Present AI/ML solutions through guided project work',
  ],
  system_administration: [
    'Install, configure, and maintain multi-user computer systems',
    'Automate tasks with scripting and documentation practices',
    'Secure local networks and internet-facing services',
    'Troubleshoot outages and performance issues proactively',
    'Manage software, protocols, and system reliability',
    'Gain sysadmin experience through structured internship',
  ],
  blockchain_development: [
    'Explain blockchain architecture and decentralized app concepts',
    'Develop smart contracts and DApp components',
    'Choose appropriate languages and tools for Web3 projects',
    'Understand security and deployment on decentralized networks',
    'Build a blockchain mini-project from idea to prototype',
    'Apply Web3 skills in an internship environment',
  ],
  photography_and_videography: [
    'Operate cameras and lighting for professional photo and video',
    'Compose shots using framing, ISO, shutter speed, and white balance',
    'Record clean audio and synchronize sound with visuals',
    'Edit footage with color correction and post-production workflows',
    'Write scripts and plan shoots for storytelling impact',
    'Produce a portfolio-ready photo/video project',
  ],
  project_management: [
    'Plan projects with scope, timeline, and resource clarity',
    'Apply PM techniques to track progress and manage risk',
    'Lead teams with strong communication and stakeholder skills',
    'Handle budgets and business constraints effectively',
    'Deliver projects from initiation through closure',
    'Prepare for PM careers with internship-backed practice',
  ],
  architechural_design: [
    'Apply architectural design vocabulary and spatial thinking',
    'Create interior and exterior scenes in 2D/3D workflows',
    'Use production utilities for efficient design output',
    'Solve design problems with creativity and systematic methods',
    'Build a mini architectural project from concept to presentation',
    'Present design work suitable for portfolio or client review',
  ],
  entrepreneurship_masterclass: [
    'Validate ideas and turn them into viable product concepts',
    'Design business models, pricing, and go-to-market plans',
    'Pitch investors and partners with confidence',
    'Incorporate a company and understand legal fundamentals',
    'Build and lead high-performing startup teams',
    'Launch growth strategies across sales, marketing, and fundraising',
  ],
  product_management: [
    'Define product vision, strategy, and roadmap alignment',
    'Conduct market research and prioritize customer needs',
    'Collaborate with engineering, design, and business stakeholders',
    'Launch products and measure success with key metrics',
    'Manage product lifecycle from discovery to iteration',
    'Build PM career readiness through capstone and internship',
  ],
  data_science: [
    'Analyze complex datasets with Python, R, and SQL',
    'Clean, visualize, and explore data for actionable insights',
    'Apply statistics and machine learning to real problems',
    'Build and validate predictive models with proper evaluation',
    'Work with cloud and big-data tools for scale',
    'Deliver a capstone predictive analytics application',
  ],
  data_engineering: [
    'Design ETL pipelines and reliable data workflows',
    'Engineer data solutions with Python, SQL, and Apache Spark',
    'Build data warehouses and models for analytics teams',
    'Deploy pipelines on AWS/GCP cloud platforms',
    'Ensure data quality, governance, and performance optimization',
    'Complete an end-to-end data pipeline capstone project',
  ],
  backend_engineering_python: [
    'Build RESTful APIs with Flask, FastAPI, and Django concepts',
    'Design databases, ORMs, and authentication systems',
    'Implement caching, async tasks, and performance optimizations',
    'Test, debug, and containerize backend services with Docker',
    'Deploy production APIs to cloud infrastructure',
    'Ship a ServiceHub API capstone ready for real users',
  ],
  product_marketing: [
    'Research markets and define customer segments',
    'Craft positioning, messaging, and brand communication',
    'Plan go-to-market launches across multiple channels',
    'Run campaigns and measure ROI with analytics',
    'Use marketing automation tools for scalable growth',
    'Design a full product launch plan as your capstone',
  ],
  technical_writing: [
    'Write clear documentation for technical and non-technical audiences',
    'Produce API docs, user guides, and software manuals',
    'Use industry tools for structured documentation workflows',
    'Edit and maintain docs as products evolve',
    'Collaborate with dev teams on documentation projects',
    'Deliver a complete documentation set as capstone work',
  ],
  cloud_engineering: [
    'Architect cloud solutions on AWS, Azure, or GCP',
    'Automate infrastructure with IaC and configuration management',
    'Containerize apps with Docker and orchestrate with Kubernetes',
    'Build CI/CD pipelines integrated with cloud services',
    'Monitor, log, and optimize cloud deployments',
    'Deploy a cloud infrastructure capstone project',
  ],
  quality_assurance: [
    'Plan tests and document QA processes thoroughly',
    'Execute functional, performance, and security testing',
    'Automate tests with industry-standard QA tools',
    'Track defects and work within agile delivery teams',
    'Test mobile apps and APIs end-to-end',
    'Build a comprehensive QA suite capstone for a web app',
  ],
  devops: [
    'Manage version control and collaborative Git workflows',
    'Implement CI/CD pipelines for fast, reliable releases',
    'Automate infrastructure with IaC and configuration tools',
    'Containerize and orchestrate apps with Docker & Kubernetes',
    'Monitor systems and integrate security into DevOps practices',
    'Deliver a full DevOps pipeline capstone project',
  ],
  'ai-automation-n8n': [
    'Design automation workflows with n8n from scratch',
    'Connect APIs, webhooks, databases, and spreadsheets',
    'Integrate OpenAI and LLMs into business automations',
    'Build AI chatbots and assistant workflows',
    'Automate email, CRM, and marketing processes',
    'Deploy an end-to-end AI automation capstone system',
  ],
  'frontend-web-development': [
    'Build semantic, accessible HTML5 page structures',
    'Style responsive layouts with CSS Flexbox, Grid, and mobile-first design',
    'Add interactivity with modern JavaScript (ES6+)',
    'Develop React components with state and reusable patterns',
    'Fetch and display data from APIs using JSON',
    'Launch a responsive frontend capstone web application',
  ],
  'advanced-artificial-intelligence-and-machine-learning': [
    'Engineer features and optimize advanced ML models',
    'Build deep learning networks including CNNs and RNNs/LSTMs',
    'Apply transformers, NLP, and LLM fundamentals',
    'Implement computer vision and object detection systems',
    'Deploy models with Flask/FastAPI and MLOps monitoring',
    'Deliver a production-ready AI capstone and advanced internship',
  ],
};

export function getLearningOutcomes(course) {
  if (course?.learningOutcomes?.length) {
    return course.learningOutcomes;
  }

  const bySlug = COURSE_OUTCOMES[course?.slug];
  if (bySlug?.length) {
    return bySlug;
  }

  return (course?.curriculum || [])
    .filter(item => !/^internship$/i.test(item.trim()))
    .slice(0, 6)
    .map(item => `Master ${item.charAt(0).toLowerCase()}${item.slice(1)}`);
}
